module.exports = __webpack_public_path__ + "img/artist7.20568312.jpeg";